import pick from 'lodash.pick';
import moment from 'moment';
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Alert, Button, Col, Collapse, Container, Row } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import Logo from '../../assets/svg/logo-blue.svg';
import Loader from "../../components/display/Loader";
import PolyUtil from "../../util/PolyUtil";
import { BoolButtonsField, InputField } from "../../validation/ReduxFormInput";
import { handleSubmitReference } from "./actions/reference";


class ReferenceForm extends Component {
    state = {
        showForm: false
    };

    content = () => {
        const {handleSubmit, _handleSubmitReference, reference, tenant_full_name, tenant_first_name, lease_start, lease_end, reference_collection_authorized, reference_collection_authorization_signature} = this.props;
        const start_str = moment(lease_start).format("MMMM") + ' ' + moment(lease_start).format('YYYY');
        const end_str = moment(lease_end).format("MMMM") + ' ' + moment(lease_end).format('YYYY');
        const address = reference.rental.address_details ? PolyUtil.getPropertyAddressString(reference.rental) : '';
        const identifier = reference.rental.identifier;

        const tenant_is_current = moment().isBefore(lease_end);

        return (
            <div>
                <div style={{display: 'flex', justifyContent: 'center'}}>
                    <img style={{maxWidth: '100px'}} src={Logo} alt="PolyRents"/>
                </div>

                <Container fluid>
                    <Row>
                        <Col md={{size: 8, offset: 2}}>
                            <div className="app-frame">
                                <div className="animated fadeIn">
                                    <Row>
                                        <h1>Rental reference for {tenant_full_name}</h1>
                                    </Row>
                                    <hr/>
                                    {
                                        !this.state.showForm && (
                                            <div>
                                                <Row>
                                                    <p>Hi there!<br /></p>
                                                    <p>A {!tenant_is_current && <span>previous </span>}tenant of yours, {tenant_full_name}, has listed one of your properties in their PolyRents rental history, so we're reaching out for a <strong>10 question, yes/no, objective rental reference</strong> on their behalf. Filling it out should take no more than a minute.</p>
                                                    <p><strong>We will not show {tenant_first_name} the reference you provide</strong> -- we will only show it to landlords of properties to which {tenant_first_name} has applied that are interested in understanding what {tenant_first_name} is like as a tenant. The more information you provide, the less likely you'll receive calls to verify or clarify the information you've provided.</p>
                                                    {
                                                        tenant_is_current &&
                                                        <p>As a final note before you get started, you being asked for a reference does not necessarily mean that {tenant_first_name} plans on moving out when the lease is up. We encourage tenants to keep all of their information up to date, including their rental history.</p>
                                                    }
                                                    <p>Feel free to reach out to us with any questions or feedback!</p>
                                                </Row>
                                                {
                                                    reference_collection_authorized && <Fragment>
                                                        <Row>
                                                            <p><strong>{tenant_first_name} has agreed to and has signed off on the authorization and indemnification clauses below. Please print/save this page for your records <em>before</em> you begin filling out your reference.</strong></p>
                                                        </Row>
                                                        <hr/>
                                                        <Row>
                                                            <p>
                                                                <br />
                                                                I, {tenant_full_name}, authorize PolyRents, Inc. to collect rental references on my behalf.
                                                                <br /><br />
                                                                I give permission to my current and former property owners, landlords, property managers, or their affiliates to release any information about my rental history to PolyRents, Inc., who may,
                                                                in turn, store and share this information with owners, landlords, property managers, or their affiliates of properties to which I apply using PolyRents.
                                                                <br /><br />
                                                                I understand that the information provided will be used for the purpose of evaluating my application for rental housing.
                                                                <br /><br />
                                                                Moreover, I shall fully indemnify, hold harmless, and defend PolyRents, Inc., as well as my current and former property owners, landlords, property managers, or their affiliates, from and against
                                                                all claims, demands, actions, suits, damages, liabilities, losses, settlements, judgments, costs and expenses (including but not limited to reasonable attorney’s fees and costs), whether or not
                                                                involving a third party claim, which arise out of or relate to the rental reference information provided to PolyRents, Inc. by said current and former property owners, landlords, property managers, or their affiliates.
                                                            </p>
                                                        </Row>
                                                        <Row>
                                                            <img src={reference_collection_authorization_signature} height="150px" alt="Tenant Signature" />
                                                        </Row>
                                                        <Row>
                                                            <p>{tenant_full_name}</p>
                                                        </Row>
                                                    </Fragment>
                                                }
                                                <div className="center">
                                                    <Button color="success" onClick={() => this.setState({showForm: true})} outline>Continue</Button>
                                                </div>
                                            </div>
                                        )
                                    }

                                    <Collapse isOpen={this.state.showForm}>
                                        <Row style={{marginBottom: '1em'}}>
                                            <Col xs={12} sm={4} style={{marginTop: '1em'}}>
                                                <h4>Property Address:</h4>
                                                {address} ({identifier})
                                            </Col>
                                            <Col xs={12} sm={3} style={{marginTop: '1em'}}>
                                                <h4>Tenant Name:</h4>
                                                {tenant_full_name}
                                            </Col>
                                            <Col xs={12} sm={5} style={{marginTop: '1em'}}>
                                                <h4>Lease Duration:</h4>
                                                {start_str} to {end_str}
                                            </Col>
                                        </Row>

                                        <form onSubmit={handleSubmit(_handleSubmitReference)} style={{marginBottom: '2rem'}}>
                                            <br />
                                            <Row>
                                                <Col xs={12} sm={6}>
                                                    <Field name="name" label="Your Name" component={InputField} type="text"/>
                                                </Col>
                                                <Col xs={12} sm={6}>
                                                    <Field name="email" label="Your Email" component={InputField} type="email"/>
                                                </Col>
                                            </Row>
                                            <br />
                                            <Row>
                                                <Col>
                                                    <p><strong>Landlords and Property Managers: </strong>If you aren't comfortable answering any of the following questions, no worries -- please answer as many as you can (at least the first one) and leave the rest blank. Blank entries will be stored as "Declined to Answer" in our system. If you accidentally clicked an answer and need to clear the form, simply reload this page to start over.</p>
                                                    <p><strong>University Housing Staff: </strong>FERPA dictates that you may only answer the first question. Please do so, and paste the standard reference letter template text into the comments section below ("This letter serves to confirm that...").</p>
                                                </Col>
                                            </Row>
                                            <hr/>
                                            {
                                                tenant_is_current &&
                                                <Row>
                                                    <Col>
                                                        <Alert color="info">
                                                            It looks like this lease is still current. We know your answers may change by the end of the lease, so we'll ask you a few questions now and then follow up when the lease ends to get updated answers.
                                                        </Alert>
                                                    </Col>
                                                </Row>
                                            }
                                            <Row>
                                                <Col>
                                                    <Field name="was_tenant" label={tenant_is_current ? "Is " + tenant_first_name + " a current tenant of yours?" : "Was " + tenant_first_name + " a tenant for the dates listed?"} component={BoolButtonsField}/>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <Field name="on_time_rent" label={tenant_is_current ? "Has " + tenant_first_name + " paid rent on time so far?" : "Did " + tenant_first_name + " pay rent on time?"} component={BoolButtonsField}/>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <Field name="insufficient_funds" label={(tenant_is_current ? "Have there been " : "Were there any ") + "insufficient funds checks?"} inverse component={BoolButtonsField}/>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <Field name="eviction" label={"Did you give " + tenant_first_name + " any 3-day notices to 'pay rent or quit' or any eviction notices?"} inverse component={BoolButtonsField}/>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <Field name="criminal_activity" label={(tenant_is_current ? "Does " : "Did ") + tenant_first_name + " or any of their guests engage in criminal activity on the property?"} inverse component={BoolButtonsField}/>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <Field name="smoking" label={(tenant_is_current ? "Does " : "Did ") + tenant_first_name + " smoke inside the property?"} inverse component={BoolButtonsField}/>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <Field name="has_pets" label={(tenant_is_current ? "Does " : "Did ") + tenant_first_name + " have any pets (non service animals)?"} inverse component={BoolButtonsField}/>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <Field name="property_condition_acceptable" label={tenant_is_current ? "Is the property currently in satisfactory condition?" : "Was the property left in satisfactory condition?"} component={BoolButtonsField}/>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <Field name="security_deposit_returned" label={tenant_is_current ? "Do you expect to be able to return the security deposit?" : "Were you able to return the security deposit?"} component={BoolButtonsField}/>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <Field name="would_rent_to_again" label={"Would you rent to " + tenant_first_name + " again?"} component={BoolButtonsField}/>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <Field name="comments" label="Any comments?" component={InputField} placeholder="Optional" type="textarea"/>
                                                </Col>
                                            </Row>
                                            <hr/>
                                            <div className="center">
                                                <Button color="success" outline>Submit Reference</Button>
                                            </div>
                                        </form>
                                    </Collapse>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        );
    };

    render() {
        return PolyUtil.polyRender(this.props, ['reference', 'tenant_full_name', 'tenant_first_name', 'lease_start', 'lease_end'], this.content, <Loader spin isLoading/>);
    }
}

const validate = (values) => {
    const errors = {};

    const truthy = (val) => {
        return val !== null;
    };

    !values.name && (errors.name = 'Required');
    !values.email && (errors.email = 'Required');
    !truthy(values.was_tenant) && (errors.was_tenant = 'Required');
    !truthy(values.on_time_rent) && (errors.on_time_rent = 'Required');
    !truthy(values.insufficient_funds) && (errors.insufficient_funds = 'Required');
    !truthy(values.eviction) && (errors.eviction = 'Required');
    !truthy(values.criminal_activity) && (errors.criminal_activity = 'Required');
    !truthy(values.smoking) && (errors.smoking = 'Required');
    !truthy(values.has_pets) && (errors.has_pets = 'Required');
    !truthy(values.property_condition_acceptable) && (errors.property_condition_acceptable = 'Required');
    !truthy(values.security_deposit_returned) && (errors.security_deposit_returned = 'Required');
    !truthy(values.would_rent_to_again) && (errors.would_rent_to_again = 'Required');
    !truthy(values.was_tenant) && (errors.was_tenant = 'Required');

    return errors;
};

ReferenceForm = reduxForm({
    form: 'reference_form',
    enableReinitialize: true,
    validate
})(ReferenceForm);

const mapStateToProps = (state) => ({
    reference: state.reference,
    reference_collection_authorized: state.reference.collection_authorization.reference_collection_authorized,
    reference_collection_authorization_signature: state.reference.collection_authorization.reference_collection_authorization_signature,
    tenant_first_name: state.reference.rental.tenant.first_name,
    tenant_full_name: state.reference.rental.tenant.first_name + " " + state.reference.rental.tenant.last_name,
    lease_start: state.reference.rental.lease_start,
    lease_end: state.reference.rental.lease_end
});

const mapDispatchToProps = (dispatch, props) => ({
    _handleSubmitReference(data) {
        return dispatch(handleSubmitReference(data, props.params.rental_id, props.params.key));
    }
});

//Get initial form values from state
ReferenceForm = connect(state => {
        let initial = Object.assign({}, pick(state.reference, [
                'name',
                'email'
            ]
        ));

        return {
            initialValues: initial
        };
    }
)(ReferenceForm);

export default connect(mapStateToProps, mapDispatchToProps)(ReferenceForm);



// WEBPACK FOOTER //
// ./src/containers/reference/ReferenceForm.js